import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const boardMeetingsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/board-meetings",
  component: lazyRouteComponent(
    () => import("@l30/web-board/pages/board-meetings.page"),
    "BoardMeetingsPage",
  ),
});
